module.exports = __webpack_public_path__ + "static/media/logo-boite-immo@3x.73382dd3.png";